import { Box, Flex } from '@rebass/grid';
import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../../constants/media';

export const Container = styled.div`
	max-width: 100%;
	padding: ${props => (props.paddingOff ? '0' : '0 3rem')};

	${media.mobileLarge`
		padding: ${props => (props.paddingOff ? '0' : '0 5rem')};
	`};

	${media.tabletOnly`
		padding: ${props => (props.paddingOff ? '0' : '0 8rem')};
	`};

	${media.desktopSmall`
		padding:  ${props => (props.paddingOff ? '0' : '0 12rem')}
	`};

	${media.containerBreakpoint`
		max-width: ${props => props.theme.pageMaxWidth}rem;
		padding: 0;
		margin: 0 auto;
	`};
`;

export const MyRegisterShipmentContainer = styled.div`
	width: 100%;
	padding: ${props => (props.paddingOff ? '0' : '0 2rem')};

	${media.mobileLarge`
		padding: ${props => (props.paddingOff ? '0' : '0 3rem')};
	`}

	${media.tabletOnly`
		padding: ${props => (props.paddingOff ? '0' : '0 4rem')};
	`}

	${media.desktopSmall`
		padding: ${props => (props.paddingOff ? '0' : '0 8rem')};
		`}

	${media.containerBreakpoint`
		max-width: 100%;
		padding: 0 8rem;
		margin: 0 auto;
	`}
`;

export const ContainerLarge = styled(Container)`
	${media.containerBreakpoint`
		max-width: 100%;
		padding: 0 12rem;
	`};

	${media.containerLargeBreakpoint`
		max-width: ${props => props.theme.pageMaxWidthLarger}rem;
		padding: 0;
		margin: 0 auto;
	`};
`;

type ColumnsProps = React.PropsWithChildren<{
	gapless?: boolean;
	flexWrap?: string;
	gap?: string;
	width?: string;
	marginBottom?: string;
}>;

export const Columns: FC<ColumnsProps> = ({ gapless, marginBottom, flexWrap, gap, children, ...props }) => {
	let rowGap = gapless ? '0' : '-1.5rem';
	if (gap) rowGap = gap;

	return (
		<Flex {...props} mx={rowGap} mb={marginBottom || '0'} flexWrap={flexWrap || 'wrap'}>
			{children}
		</Flex>
	);
};

export const Row = Columns;

type ColumnProps = React.PropsWithChildren<{
	mobile?: string | number;
	mobileMedium?: string | number;
	mobileLarge?: string | number;
	tablet?: string | number;
	desktopSmall?: string | number;
	desktopLarge?: string | number;
	retina?: string | number;
	gapless?: string | number;
	flex?: string | number;
	width?: string | number;
	style?: any;
	gap?: string;
	props?: any[];
	marginTop?: string;
	marginBottom?: string | number;
	paddingLeft?: string;
	ref?: React.Ref<HTMLDivElement>;
}>;

export const Column: FC<ColumnProps> = ({
	mobile,
	mobileMedium,
	mobileLarge,
	tablet,
	desktopSmall,
	desktopLarge,
	retina,
	gapless,
	flex,
	width,
	gap,
	marginTop,
	marginBottom,
	paddingLeft,
	children,
	...props
}) => {
	const breakpoints = [
		'100%',
		mobile || '100%',
		mobileMedium || mobile || '100%',
		mobileLarge || mobileMedium || mobile || '100%',
		tablet || mobileLarge || mobileMedium || mobile || '100%',
		desktopSmall || tablet || mobileLarge || mobileMedium || mobile || '100%',
		desktopLarge || desktopSmall || tablet || mobileLarge || mobileMedium || mobile || '100%',
		retina || desktopLarge || desktopSmall || tablet || mobileLarge || mobileMedium || mobile || '100%',
	];

	let columnGap = gapless ? 0 : '1.5rem';
	if (gap) columnGap = gap;
	const defaultFlex =
		mobile || mobileMedium || mobileLarge || tablet || desktopSmall || desktopLarge || retina ? 'none' : '1 1 auto';
	paddingLeft = paddingLeft || '1.5rem';
	return (
		<Box
			width={width || breakpoints}
			{...props}
			px={columnGap}
			mb={marginBottom ?? columnGap}
			flex={flex || defaultFlex}
			mt={marginTop}
			pl={paddingLeft}>
			{children}
		</Box>
	);
};
